import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export type DeleteProductRequest = {
  id: number;
  status: "ACTIVE" | "PASSIVE" | "DELETED";
};

export type DeleteProductResponse = BaseResponse<null>;

async function deleteProduct(
  data: DeleteProductRequest
): Promise<DeleteProductResponse> {
  try {
    return (await axiosInstance.delete(`/Product/DeleteProduct?id=${data.id}&status=${data.status}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useDeleteProduct() {
  return useMutation<DeleteProductResponse, Error, DeleteProductRequest>(
    (variables) => deleteProduct(variables)
  );
}
